const APIS = {
  GRID_REPORT_DATA: '/projectsettingsservice/api/logistic-grid-report/',
  ORDER: '/logisticservice/api/order/',
  STATUS: '/logisticservice/api/status/',
  BRANCH: '/logisticservice/api/branch/',
  USER: 'usermanagementservice/api/user/',
  DRAFT_ORDER: '/pickuprequestservice/api/order/draft-orders/',
  LOCATION: '/logisticservice/api/location/',
  CACHE: '/cacheservice/api/invalidate-cache/',
};

export default APIS;
